// extracted by mini-css-extract-plugin
export default {"certificate":"style_certificate__97bAa","certificateList":"style_certificateList__YhNWN"};